import { render } from "./CCMenuComponent.vue?vue&type=template&id=0c014192&scoped=true"
import script from "./CCMenuComponent.vue?vue&type=script&lang=ts"
export * from "./CCMenuComponent.vue?vue&type=script&lang=ts"

import "./CCMenuComponent.vue?vue&type=style&index=0&id=0c014192&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0c014192"

export default script